export const ChildrenTypes = [
    { value: '0', label: '0 (No Children)' },
    { value: '1', label: '1 (1 Child)' },
    { value: '2', label: '2 (2 Children)' },
    { value: '3', label: '3 (3 Children)' },
    { value: '4', label: '4 (4 Children)' },
    { value: '5', label: '5 (5 Children)' },
    { value: '6', label: '6 (6 Children)' },
    { value: '7', label: '7 (7 Children)' },
    { value: '8', label: '8 (8 Children)' },
    { value: '9', label: '9 (9 Children)' },
    { value: '10', label: '10 (10 Children)' }
]

export type ChildrenType = typeof ChildrenTypes[number]['value']